<template>
  <div class="content">
    <div class="left-content">
      <tree-components
        ref="treeComponents"
        :treeList='treeList'
        :defaultProps='defaultProps'
        :activeNode='activeNode'
        @handleNodeChange='handleNodeChange'
        @handleGetTreeList='handleGetTreeList'
        >
      </tree-components>
    </div>
    <div class="right-content">
      <div class="search-content">
        <el-form :inline="true" :model="filters" size="small" @keyup.enter.native="handleGetData">
          <el-form-item label="时间类型">
            <el-select v-model="filters.timeType" @change="handleTimeTypeChange" style="width: 100px" placeholder="请选择">
              <el-option :value="0" label="日"></el-option>
              <el-option :value="1" label="月"></el-option>
              <el-option :value="2" label="年"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item >
            <el-date-picker v-if="filters.timeType === 0" v-model="filters.time" type="date" style="width: 160px" key="day" placeholder="选择日期"></el-date-picker>
            <el-date-picker v-if="filters.timeType === 1" v-model="filters.time" type="month" style="width: 160px" key="month" placeholder="选择日期"></el-date-picker>
            <el-date-picker v-if="filters.timeType === 2" v-model="filters.time" type="year" style="width: 160px" key="year" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item >
            <el-select v-model="filters.collectType" @change="handleCollectTypeChange" style="width: 120px" placeholder="请选择">
              <el-option :value="0" label="全部"></el-option>
              <el-option v-for="item in collectTypeList" :value="item.code" :label="item.label" :key="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleGetData">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleExport">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <el-table id="table" ref="table" class="simple-table" :data="tableData" max-height="700px" highlight-current-row fit border >
          <el-table-column prop="time" label="时间" align="center" min-width="150" header-align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="room" label="房间" align="center" min-width="100" header-align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="switch" label="开关" align="center" min-width="100" header-align="center" show-overflow-tooltip></el-table-column>
          <el-table-column v-for="column in columns" header-align="center" :align="column.align?column.align:'center'"
            :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth"
            :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/index.js'
import treeComponents from './components/treeComponents.vue'
export default {
  name: 'dataReport',
  components: {
    treeComponents
  },
  data () {
    return {
      filters: {
        timeType: 0,
        time: new Date(),
        daterange: [new Date(), new Date()],
        dataType: 'hour',
        collectType: 0
      },
      collectType: [201, 202, 203, 207, 208, 209, 211, 215, 223],
      collectTypeList: [
        { code: 201, label: 'A相电压' },
        { code: 202, label: 'B相电压' },
        { code: 203, label: 'C相电压' },
        { code: 207, label: 'A相电流' },
        { code: 208, label: 'B相电流' },
        { code: 209, label: 'C相电流' },
        { code: 211, label: '总有功功率' },
        { code: 215, label: '总无功功率' },
        { code: 223, label: '总视在功率' },
      ],
      typeNameList: {
        201: 'A相电压',
        202: 'B相电压',
        203: 'C相电压',
        207: 'A相电流',
        208: 'B相电流',
        209: 'C相电流',
        211: '总有功功率',
        215: '总无功功率',
        223: '总视在功率'
      },
      activeNode: '',
      treeList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      switchList: [],
      tableData: [],
      columns: []
    }
  },
  created () {
    this.handleGetTreeList()
  },
  methods: {
    handleCollectTypeChange (val) {
      if (val === 0) {
        this.collectType = [ 201, 202, 203, 207, 208, 209, 211, 215, 223 ]
      } else {
        this.collectType = [ val ]
      }
    },
    handleNodeChange (data) {
      this.activeNode = data.id
      this.$nextTick(() => {
        this.$refs['treeComponents'].handleSetCurrentKey(this.activeNode)
      })
      this.dataList = this.handleGetAllLeaf([data])
      this.handleGetRoomSwitches()
    },
    handleGetAllLeaf (data) {
      let result = []
      const getLeaf = (nodeList) => {
        nodeList.forEach((item) => {
          if (item.children.length === 0) {
            result.push(item)
          } else {
            getLeaf(item.children)
          }
        })
      }
      getLeaf(data)
      return result
    },
    handleSwitchChange (data) {
      this.activeSwitch = data.id
    },
    handleGetTreeList () {
      this.treeList = []
      this.$api.rentalArea.getRentalAreaTrusteeshipContractForProperty(0, [], '', '', '', '', 1).then((res) => {
        if (res.success) {
          let areaList = []
          res.data.forEach((item) => {
            areaList = areaList.concat(item.areas)
          })
          let areaIdList = areaList.map((item) => {
            return item.id
          })
          this.$api.rentalArea.getSubRentalAreas(areaIdList, 1).then((res) => {
            if (res.success) {
              this.handleTreeList(res.data)
              this.dataList = [res.data[0]]
              this.handleNodeChange(res.data[0])
            }
          })
        }
      })
    },
    handleTreeList (list) {
      let allListId = list.map((item) => {
        return item.id
      })
      // 找不到parentId的，pid为0
      list.forEach((item) => {
        item.pid = item.parentId
        if (allListId.indexOf(item.parentId) === -1) {
          item.pid = 0
        }
      })
      this.treeList = this.handleRecursion(list, 0)
    },
    handleRecursion (list, pid) {
      let arr = []
      list.forEach((item) => {
        if (item.pid === pid) {
          item.children = this.handleRecursion(list, item.id)
          arr.push(item)
        }
      })
      return arr
    },
    handleGetRoomSwitches () {
      this.switchList = []
      let requestList = this.dataList.map((item) => {
        return this.$api.rentalArea.getRentalAreaSwitches(item.id)
      })
      Promise.all(requestList).then((res) => {
        if (res[0].success) {
          res.forEach((item, index) => {
            let list = item.data.map((item) => {
              return {
                ...item,
                room: this.dataList[index].name
              }
            })
            this.switchList = this.switchList.concat(list)
          })
          console.log(this.switchList)
          this.handleGetData()
        }
      })
    },
    handleGetData () {
      this.tableData = []
      this.columns = []
      this.columns = this.collectType.map((item) => {
        return { prop: 'point' + item, label: this.typeNameList[item], minWidth: 100, align: 'right' }
      })
      let startTime = ''
      let endTime = ''
      let time = ''
      switch (this.filters.timeType) {
        case 0:
          startTime = this.$moment(this.filters.time).startOf('d').format('yyyy/MM/DD HH:mm:ss')
          endTime = this.$moment(this.filters.time).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
          time = this.$moment(this.filters.time).format('yyyy-MM-DD')
          break
        case 1:
          startTime = this.$moment(this.filters.time).startOf('month').format('yyyy/MM/DD HH:mm:ss')
          endTime = this.$moment(this.filters.time).add(1, 'M').startOf('month').format('yyyy/MM/DD HH:mm:ss')
          time = this.$moment(this.filters.time).format('yyyy-MM')
          break
        case 2:
          startTime = this.$moment(this.filters.time).startOf('year').format('yyyy/MM/DD HH:mm:ss')
          endTime = this.$moment(this.filters.time).add(1, 'Y').startOf('year').format('yyyy/MM/DD HH:mm:ss')
          time = this.$moment(this.filters.time).format('yyyy')
          break
      }
      let requestList = this.switchList.map((item) => {
        let measures = this.collectType.map((collect) => {
          return {
            measureId: item.id,
            pointNumber: 0,
            pointCode: collect
          }
        })
        return this.$api.measuring.getMeasuringValueDay2(measures, startTime, endTime, 0)
      })
      Promise.all(requestList).then((res) => {
        if (res[0].success) {
          let list = []
          try {
            for (let i = 0; i < res.length; i++) {
              let point = {}
              for (let j = 0; j < res[i].data.length; j++) {
                point['point' + res[i].data[j].pointCode] = res[i].data[j].data.data[0].value
              }
              console.log(point)
              list.push({
                time: time,
                room: this.switchList[i].room,
                switch: this.switchList[i].name,
                ...point
              })
              console.log(list)
            }
          } catch (error) {
            console.log(error)
          }
          this.tableData = list
        }
      })
    },
    handleExport () {
      let selectedDate = {
        dateType: 'day',
        startTime: new Date(),
        endTime: new Date()
      }
      exportExcel('table', '运行分析', selectedDate)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  .left-content {
    width: 240px;
    height: 100%;
    // border: 1px solid;
    box-sizing: border-box;
  }
  .right-content {
    text-align: left;
    // display: flex;
    margin-left: 16px;
    width: calc(100% - 256px);
    height: 100%;
    // border: 1px solid;
    box-sizing: border-box;
    .switch-tree {
      width: 180px;
      height: 100%;
    }
    .main {
      margin-left: 16px;
      box-sizing: border-box;
      height: 100%;
      width: calc(100% - 196px);
      .chart-content {
        width: 100%;
        height: 300px;
      }
    }
  }
}
</style>
